import recurrentEntityActionTypes from '../../constants/actions/admin/recurrentEntityAdmin'

export function fetchRecurrentEntityList (filter) {
  return {
    type: recurrentEntityActionTypes.FETCH_RECURRENT_ENTITY_ADMIN,
    filter
  }
}

export function fetchRecurrentEntityAdminSuccess (recurrentEntities, filter) {
  return {
    type: recurrentEntityActionTypes.FETCH_RECURRENT_ENTITY_ADMIN_SUCCESS,
    recurrentEntities,
    filter
  }
}

export function fetchDocumentList (entityId) {
  return {
    type: recurrentEntityActionTypes.FETCH_DOCUMENT_LIST_ADMIN,
    entityId
  }
}

export function fetchDocumentListAdminSuccess (documents, entityId) {
  return {
    type: recurrentEntityActionTypes.FETCH_DOCUMENT_LIST_ADMIN_SUCCESS,
    documents,
    entityId
  }
}

export function openEditRecurrentEntityModal (recurrentEntityId) {
  return {
    type: recurrentEntityActionTypes.OPEN_EDIT_RECURRENT_ENTITY_MODAL,
    entityId: recurrentEntityId
  }
}

export function openEditRecurrentEntityModalSuccess (recurrentEntity) {
  return {
    type: recurrentEntityActionTypes.OPEN_EDIT_RECURRENT_ENTITY_MODAL_SUCCESS,
    recurrentEntity
  }
}

export function openAddRecurrentEntityModal () {
  return {
    type: recurrentEntityActionTypes.OPEN_ADD_RECURRENT_ENTITY_MODAL
  }
}

export function openAddRecurrentEntityModalSuccess () {
  return {
    type: recurrentEntityActionTypes.OPEN_ADD_RECURRENT_ENTITY_MODAL_SUCCESS
  }
}

export function closeEditRecurrentEntityModal () {
  return {
    type: recurrentEntityActionTypes.CLOSE_EDIT_RECURRENT_ENTITY_MODAL
  }
}

export function submitRecurrentEntity (recurrentEntityId, body, filter) {
  return {
    type: recurrentEntityActionTypes.SUBMIT_RECURRENT_ENTITY,
    entityId: recurrentEntityId,
    body,
    filter
  }
}

export function deleteRecurrentEntity (recurrentEntityId, filter) {
  return {
    type: recurrentEntityActionTypes.DELETE_RECURRENT_ENTITY,
    recurrentEntityId,
    filter
  }
}

export function fetchEntitySubTypesList () {
  return {
    type: recurrentEntityActionTypes.FETCH_ENTITY_SUB_TYPES_LIST
  }
}

export function fetchEntitySubTypesListSuccess (recurrentEntitySubTypesList) {
  return {
    type: recurrentEntityActionTypes.FETCH_ENTITY_SUB_TYPES_LIST_SUCCESS,
    recurrentEntitySubTypesList
  }
}

export function uploadRecEntMassDocument (files, code, callback, resolve, t) {
  return {
    type: recurrentEntityActionTypes.UPLOAD_REC_ENTITY_MASS_DOCUMENT,
    files,
    code,
    callback,
    resolve,
    t
  }
}

export function setChangeTabFromMaster (ouIdFromMaster, changeTabFromMaster) {
  return {
    type: recurrentEntityActionTypes.SET_CHANGE_TAB_FROM_MASTER,
    ouIdFromMaster,
    changeTabFromMaster
  }
}

export function setChangeTabFromMasterSuccess (ouIdFromMaster, changeTabFromMaster) {
  return {
    type: recurrentEntityActionTypes.SET_CHANGE_TAB_FROM_MASTER_SUCCESS,
    ouIdFromMaster,
    changeTabFromMaster
  }
}
